import { useCallback, useEffect, useState } from "react";
import { attachmentBase, attachmentClient, attachmentError } from "@/lib/invoiceAttachments";

export const useInvoiceAttachments = (invoiceId, viewer, refreshKey = 0) => {
  const [state, setState] = useState({ items: [], loading: true, error: "" });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setState({ items: [], loading: true, error: "" });
    attachmentClient(viewer).get(attachmentBase(invoiceId, viewer), { signal: controller.signal })
      .then(({ data }) => { if (!controller.signal.aborted) setState({ items: data.items, loading: false, error: "" }); })
      .catch(error => { if (!controller.signal.aborted) setState({ items: [], loading: false, error: attachmentError(error) }); });
    return () => controller.abort();
  }, [invoiceId, viewer, refreshKey, attempt]);
  return { ...state, load: useCallback(() => setAttempt(value => value + 1), []) };
};